module.exports = __webpack_public_path__ + "img/pledge-big-2.f8ec086a.jpg";